<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Items from '../components/Items.svelte'; 
    import MenuItems from '../components/MenuItems.svelte';
    import { add_location } from 'svelte/internal';

   
    let menuItems = [];
    let menuItems_nested = [];
    let categories_sync = [] 
    let categories_sync_filtered = [];
    let menuLevel = 0;
    let selectedItem = {};
    let popup = false;
    let searchTerm = '';
    let new_category_value = '';

    
    onMount(async() => {

      getCategories();        
        
    })

    async function getCategories() {

      let postData = {};

      postData.action = 'categories';
      postData.token = $UserStore.token
      let response = await fetchData(postData);
      if (response.success==1) {
        menuItems = response.data;        
        categories_sync = response.sync
        categories_sync_filtered = response.sync;
      }

    }

    function openCategoryBox(event) {

      console.log('categoties',event.detail)
      selectedItem = event.detail;
      popup = true;

    }

    function closePopup() {
      popup = false;
    }


    async function save() {

      let postData = {};

        postData.action = 'save_categories';
        postData.data = menuItems
        postData.token = $UserStore.token
        let response = await fetchData(postData);
        if (response.success==1) {
          getCategories();  

        }
    }

    async function add() {

      let postData = {};

      postData.action = 'add_categories';
      postData.name = new_category_value
      postData.token = $UserStore.token
      let response = await fetchData(postData);

      if (response.success==1) {

        new_category_value = '';

        getCategories();

      }
    }


    $: {
      // Filter categories based on searchTerm
      categories_sync_filtered = categories_sync.filter(cat => {
        return cat.name.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }




    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Header />
    <div class="page">

        <TopInfo />   
        <div style="padding-top:20px">
          <input type="text" bind:value={new_category_value}><button on:click={()=> { add() } }>add category</button>
        </div>

        <MenuItems originalMenuItems={menuItems} {menuItems} {categories_sync} {menuLevel} on:openCategoryBox={openCategoryBox}/>

        <button on:click={()=> { save() } }>save</button>        
        
    </div>    
</div>



<style>
  .list {
    overflow-y: auto;
    max-height: 500px;;
  }
  .page {
    position: relative;
  }
  .popup_close {
    background-color: var(--blue-color);
    color: white;
    display: inline-block;
    padding-top: 5px;
    border-radius: 50%;
    position: absolute;
    top: 5px;
    left: 5px;
    width: 30px;
    height: 25px;
    text-align: center;
    line-height: 18px;
    cursor: pointer;
  }
  .popup {
    position: fixed;
    top:20px;
    padding:20px;
    right:0;
    left:0;
    margin: auto;
    width:600px;
    background-color: white;
    z-index: 1;
    box-shadow: 0 0 10px 5px rgb(227, 227, 227);
    border-radius: 10px;;
  }
  .sync_cat {
    padding:5px;
    margin: 5px;;
    background-color: rgb(205, 216, 255);
    border-radius: 2px;
    display: inline-block;
    font-size: 12px;
  }
  .connected {
    background-color: rgb(81 95 145);
    color: #fff;
  }
  ul {
    list-style: none;
    padding-left: 0;
  }

  li {
    margin-bottom: 5px;
  }

  span {
    cursor: pointer;
  }
</style>